import { render, staticRenderFns } from "./HomeStatistics.vue?vue&type=template&id=cbb05a1a&"
import script from "./HomeStatistics.vue?vue&type=script&lang=js&"
export * from "./HomeStatistics.vue?vue&type=script&lang=js&"
import style0 from "./HomeStatistics.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports